import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  content: FelaCSS;
  searchWrap: FelaCSS;
  textWrapper: FelaCSS;
  title: FelaCSS;
  subTitle: FelaCSS;
  hubAd: FelaCSS;
  imgWrapper: FelaCSS;
  img: FelaCSS;
  adText: FelaCSS;
  adTitle: FelaCSS;
  adSubTitle: FelaCSS;
  startPlanningBtn: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    marginBottom: 4,
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxWidthMobile: {
      marginBottom: 0,
      flexDirection: 'column-reverse',
    },
  },

  content: {
    flexDirection: 'row',
  },

  searchWrap: {
    marginRight: '20px',

    maxWidthMobile: {
      display: 'none',
    },
  },
  textWrapper: {
    paddingLeft: 0,
    paddingVertical: 8,
    paddingRight: 8,
    marginTop: 2,

    maxWidthMobile: {
      padding: 0,
      marginTop: 4,
    },
  },
  title: {
    fontPlayfair: 48,
    maxWidthMobile: {
      fontPlayfair: 32,
    },
  },
  subTitle: {
    maxWidth: 700,
    fontDefault: 16,
  },
  hubAd: {
    borderRadius: '8px',
    boxSizing: 'border-box',
    marginVertical: 4,
    padding: 4,
    backgroundColor: colors.pinkJoy,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    gap: 10,

    maxWidthMobile: {
      marginTop: 0,
    },
  },
  imgWrapper: {
    justifyContent: 'flex-end',
  },
  img: {
    maxWidth: 174,
  },
  adText: {
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    maxWidthMobile: {
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'center',
      gap: 12,
      flexDirection: 'row',
    },
  },
  adTitle: {
    textAlign: 'left',
    fontDefaultSemiBold: 16,
    paddingVertical: 1,
  },
  adSubTitle: {
    paddingBottom: 1,
    fontDefault: 12,
    maxWidth: 260,
  },
  startPlanningBtn: {
    whiteSpace: 'nowrap',
  },
});

export default styles;
